import { Plugin } from "prosemirror-state";
import { Extension } from "../../core/extension";
import { SlashCommandGroup } from "../../core/types";
import { ReactPluginView } from "../../react";
import { insertDateCommand } from "./commands";
import { DatePillPluginView } from "./components/DatePillPluginView";
import { datePillNodeSpec } from "./schema";
export class DatePillExtension extends Extension {
    addNodes(nodes) {
        return nodes.append(datePillNodeSpec());
    }
    addPlugins(schema, plugins, { portalContainer }) {
        return plugins.concat([
            new Plugin({
                view: ReactPluginView.create({
                    portalContainer,
                    component: DatePillPluginView,
                }),
            }),
        ]);
    }
    addSlashCommands(commands) {
        return [
            ...commands,
            {
                label: `Insert Date`,
                description: `Insert a Date using a calendar`,
                group: SlashCommandGroup.Basics,
                icon: "calendar",
                command: insertDateCommand(),
            },
        ];
    }
}
